import axios from 'axios';
import { API_CONFIG } from '../config/api';

const api = axios.create({
  baseURL: API_CONFIG.baseURL,
  timeout: API_CONFIG.timeout || 30000,
  headers: API_CONFIG.headers,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('authToken');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const billingDocService = {
  list: async (params = {}) => {
    const response = await api.get('/billing-documents', { params });
    return response.data;
  },
  listByPatient: async (patientId) => {
    const response = await api.get(`/billing-documents/patient/${patientId}`);
    return response.data;
  },
  create: async (data) => {
    const response = await api.post('/billing-documents', data);
    return response.data;
  },
  update: async (id, data) => {
    const response = await api.patch(`/billing-documents/${id}`, data);
    return response.data;
  },
  approve: async (id) => {
    const response = await api.post(`/billing-documents/${id}/approve`);
    return response.data;
  },
  markExported: async (id) => {
    const response = await api.post(`/billing-documents/${id}/export`);
    return response.data;
  },
  draftFromAppointment: async (appointmentId) => {
    const response = await api.post(`/billing-documents/from-appointment/${appointmentId}`);
    return response.data;
  },
};

export default billingDocService;
